<template>
    <div class="w-full">
        <div class="box_info">
            <img src="../icons/bulb-icon.svg" />
            <p>Your default shipping service is {{ $store.state?.authentication?.organizationDetails?.companyname }} Logistics - {{ $store.getters?.currentLocation?.location?.locationName }}. Choose whether to proceed with this
                carrier or broadcast the shipment to all available 3PLs.</p>
        </div>
        <div class="flex justify-between weight_box">
            <p class="flex-1 text_weight"> <img src="../icons/pkg-img.svg" />Total package weight</p>
            <b class="weight_label">{{ totalWeight }}Kg</b>
        </div>

        <div v-if="isPODOpen" class=" bg-gray-200 rounded-md p-4 mb-4 overflow-auto w-full">
            <div v-for="(doc, index) in checkedDispatchableDetail" :key="index" class=" min-width_600">
                <div class="proof-header">
                    <div class="flex-2">
                        <p class=" font-semibold text-sm">{{ doc?.receiver?.contactName || 'N/A' }}</p>
                        <p class=" text-sm text-gray-400">{{ doc?.receiver?.mobile || '' }}</p>
                    </div>

                    <p class="text-[#383F51] text-[12px] font-normal flex-1 px-3 pr-1">{{
                        doc?.receiver?.address?.address }}
                        shipment</p>
                    <p class="text-[#10233E] text-[12px] font-normal flex-1 text-center">{{ doc?.packages?.length }}
                        items</p>
                </div>

                <div v-if="isPODOpen">
                    <div class="table-row pl-6" v-for="(bod, index) in doc.shipments" :key="index">
                        <div>
                            <h3 class="text-[#383F51] text-[14px] font-semibold mb-2">{{ bod?.location?.contactName
                                }}
                            </h3>
                            <h3 class="text-[#383F51] text-[12px] font-normal">{{ bod?.location?.mobile }}</h3>
                        </div>
                        <p class="text-[#383F51] text-[12px] font-normal text-center">{{
                            bod?.location?.address?.address
                            }}</p>
                        <p class="text-[#10233E] text-[12px] font-normal text-center">{{
                            bod?.shipping?.packagees?.length }} item</p>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="mt-2">
                <h3 class="text-[#10233E] text-[16px] font-normal mb-2">Route</h3>
                <p class="text-[#383F51] text-[14px] font-normal rvcdp h-10">{{ route }}</p>
            </div>

            <div class="mt-4">
                <h3 class="text-[#10233E] text-[16px] font-normal mb-2">Vehicle/ Carrying Capacity</h3>
                <el-select :disabled="automaticBroadcast" v-model="dispatch.vehicle" placeholder="Select state">
                    <el-option v-for="dispatch in dispatchSummary" :key="dispatch.type"
                        :label="capitalize(dispatch.type)" :value="dispatch.type">
                    </el-option>
                </el-select>
            </div>

            <div class="mt-1 ">
                <h3 class="text-[#10233E] text-[16px] font-normal mb-2">Driver</h3>
                <el-select :disabled="automaticBroadcast" v-model="dispatch.id" placeholder="Select state">
                    <el-option v-for="dispatch in driversOptions" :key="dispatch.id"
                        :label="capitalize(`${dispatch.user?.firstname} ${dispatch.user?.lastname}`)"
                        :value="dispatch.id">
                    </el-option>
                </el-select>
            </div>

            <div class="mt-2">
                <h3 class="text-[#10233E] text-[16px] font-normal mb-2">Plate Number</h3>
                <p class="text-[#383F51] text-[14px] font-normal rvcdp h-10">{{ getVehicleInfo?.vehicleNumber ||
                    "--Autoloaded--" }}</p>
            </div>
        </div>

        <div class=" flex items-center gap-2 mt-4 mb-2">
            <input class="base_checkbox" type="checkbox" v-model="automaticBroadcast" @change="setAutomaticEvent" />
            <span class=" text-sm">Enable automatic broadcast to all available riders across the platform.</span>
        </div>

        <div class="button_wrapper">
            <button @click="$emit('close-modal')">Cancel</button>
            <base-button text="Continue" :loading="loading" @click="createlastmileDispatch" :disabled="isDisabled" />
        </div>
    </div>
</template>

<script>
import { userId } from "@/services/apiConfig.js";

export default {
    components: {},
    props: {
        selecetedActionShipment: {},
        showModal: {
            type: Boolean,
            required: true,
            default: false,
        },
        createdBooking: {}
    },
    data() {
        return {
            isPODOpen: false,
            loading: false,
            dispatchSummary: [],
            automaticBroadcast: false,
            dispatch: {
                vehicle: "",
                id: null
            }
        }
    },
    mounted() {
        this.getLongHaulSummaryLastMile()
    },
    activated() {
        this.getLongHaulSummaryLastMile()
    },
    computed: {
        locationId() {
            return this.$store.getters.currentLocationId;
        },
        isDisabled() {
            if (this.automaticBroadcast) return false;
            return (this.dispatch.vehicle === "" || this.dispatch.id === null)
        },
        payload() {
            return {
                receiverIds: (this.createdBooking?.shipmentReceiever || []).map((item) => item?.id),
                fleetId: this.automaticBroadcast ? null : this.dispatch?.id,
                userId: userId(),
                enableAutobroadCast: this.automaticBroadcast,
                terminalId: this.locationId
            }
        },
        totalWeight() {
            return (this.createdBooking?.shipmentReceiever || []).reduce((total, shipment) => {
                const shipmentWeight = (shipment.packagees || []).reduce(
                    (sum, pkg) => sum + Number(pkg.estimatedWeight || 0),
                    0
                );

                return total + shipmentWeight;
            }, 0);
        },
        itemcount() {
            return (this.createdBooking?.shipmentReceiever || []).reduce(
                (total, shipment) => total + (shipment.packagees?.length || 0),
                0
            );
        },
        route() {
            const destination = (this.createdBooking?.shipmentReceiever || []).map((item) => {
                return `${item?.location?.address?.state}-${item?.location?.address?.state}`
            }).join(" ")

            return `${this.createdBooking?.shipperlocation?.address?.state}-${destination}`
        },
        getVehicleInfo() {
            return (this.driversOptions || []).filter((item) => item.id === this.dispatch?.id)[0]
        },
        driversOptions() {
            return (this.dispatchSummary || []).filter((item) => item.type === this.dispatch?.vehicle)[0]?.fleets
        },
        currentLocation() {
            return this.$store.getters.currentLocation;
        },

    },
    watch: {
        showModal(val) {
            if (val) {
                this.getLongHaulSummaryLastMile()
            }
        }
    },
    methods: {
        setAutomaticEvent($event) {
            this.automaticBroadcast = $event?.target?.checked
        },
        async createlastmileDispatch() {
            this.loading = true;
            try {
                // await this.$_greateLastMileDispatch(this.payload);
                this.$store.dispatch('setThirdPartySelectedDispatch', this.payload);
                const driverOtp = (this.driversOptions || []).find((item) => item?.id === this.dispatch?.id);
                if (this.automaticBroadcast) {
                    this.$store.dispatch("setSelecetedBrodcastDriver", null)
                } else {
                    this.$store.dispatch("setSelecetedBrodcastDriver", driverOtp)
                }
                this.$store.dispatch('setSavedActiveTab', 3);
            } catch (error) {
                this.handleError(error)
            } finally {
                this.loading = false;
            }
        },
        async getLongHaulSummaryLastMile() {
            try {
                this.loading = true;
                const { data: response } = await this.$_getDispatchSummaryLastMile();
                this.dispatchSummary = response.data

            } catch (error) {
                this.handleError(error);
            } finally {
                this.loading = false;
            }
        },
        togglePOD() {
            this.isPODOpen = !this.isPODOpen;
        },
        closeModal() {
            this.$emit("close-modal");
        },
        goBack() {
            this.$emit("go-back");
            this.closeModal() // Close the POD section when going back
        },

    }

};

</script>

<style scoped>
.text_weight {
    @apply text-gray-600 gap-2 items-center flex font-[300]
}

.weight_label {
    @apply inline-block px-4 py-1 rounded-lg border-[1px] border-primary-yellow bg-primary-yellow/10 text-primary-yellow
}

.weight_box {
    @apply justify-between items-center border-[1px] border-primary-yellow/20 p-3 py-2 rounded-lg mb-4
}

.box_info {
    @apply flex gap-3 py-2 px-3 rounded-md bg-primary-yellow/20 mb-4
}

.min-width_600 {
    @apply min-w-[400px]
}

.proof-header {
    display: flex;
    justify-content: space-between;
    padding-top: 15px;
    padding-bottom: 15px;
    cursor: pointer;
}

/* Arrow rotation */
.arrow {
    display: inline-block;
    transition: transform 0.3s ease;
}

.arrow.open {
    transform: rotate(180deg);
}


.header-wrap>p {
    text-align: center;
    font-weight: 400;
    font-size: 14px;
}

.table-row {
    background: #7A90A71A;
    border-radius: 15px;
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 10px;
    /* padding-left: 10px; */
}

.button_wrapper {
    @apply mt-7 flex justify-end gap-5
}

.rvcdp {
    background: #ebf2faa0;
    padding: 10px 0 10px 10px;
}

.base_checkbox {
    width: 1.4rem;
    height: 1.4rem;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    background-color: #e5e7eb;
    /* gray */
    border: none;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.25rem;
}

.base_checkbox:checked {
    background-color: #facc15;
    /* your yellow */
}

.base_checkbox:checked::after {
    content: "";
    margin-top: -2px;
    width: 0.35rem;
    height: 0.7rem;

    border: solid white;
    border-width: 0 2px 2px 0;

    transform: rotate(45deg);
    display: block;
}
</style>